import { Box, Typography } from "@mui/material";
import theme from "../../../../../theme";
import { SOMContentGridStyle } from ".";
import { SPACING } from "../../../../../utils/constants/designConstants";

export const SOMContentSection = ({ sizeOfMarketContent }) => {
  return (
    <Box sx={{ my: 5 }}>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            sm: "1fr",
            md: "repeat(2, 1fr)",
            lg: "repeat(2, 1fr)",
            xl: "repeat(2, 1fr)",
          },
          gap: { xs: 3, sm: 3, md: 5, lg: 5, xl: 5 },
        }}
      >
        {(sizeOfMarketContent.sections || []).map((section, sectionIndex) => (
          <Box key={sectionIndex}>
            <Box sx={{ mb: SPACING.SUBHEADING_BOTTOM }}>
              <Typography
                variant="subtitle3"
                sx={{
                  color: "primary.brandMain",
                }}
              >
                {section.title}
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 2,
              }}
            >
              {(section.bullets || []).map((bullet, bulletIndex) => (
                <Box key={bulletIndex} sx={{ display: "flex", gap: 1 }}>
                  <Typography
                    variant="body1"
                    sx={{ color: "primary.white", wordBreak: "break-word" }}
                  >
                    {bullet}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Box>
        ))}
        <FurtherReadingContent
          furtherReading={sizeOfMarketContent.furtherReading || []}
        />
      </Box>
    </Box>
  );
};

const FurtherReadingContent = ({ furtherReading }) => {
  if (furtherReading.length === 0) return null;
  return (
    <Box
      sx={{
        gridColumn: {
          xs: "1",
          sm: "1",
          md: "2",
          lg: "2",
          xl: "2",
        },
        display: "flex",
        justifyContent: "center",
        alignSelf: "end",
      }}
    >
      <Box
        sx={{
          width: { xs: "100%", md: "350px" },
          maxWidth: "100%",
        }}
      >
        <Box
          sx={{
            p: { xs: 2, sm: 2, md: 3 },
            border: "1px solid",
            borderColor: "primary.brandMain",
            boxShadow: `4px 4px 12px 5px ${theme.palette.primary.brandMain}60`,
            borderBottomLeftRadius: theme.borderRadius.xxxl,
            backgroundColor: "primary.main",
            mt: { xs: 0, sm: 0, md: 26, xl: 26 },
          }}
        >
          <Typography
            variant="subtitle3"
            component="subtitle3"
            sx={{
              color: "primary.white",
              fontWeight: 600,
            }}
          >
            Further Reading
          </Typography>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: SPACING.ITEM_GAP,
              mt: { xs: 2, md: 4 },
            }}
          >
            {furtherReading.map((item, itemIndex) => (
              <Box key={itemIndex} sx={{ display: "flex", gap: 1 }}>
                <Typography
                  variant="body2"
                  sx={{ color: "primary.white", wordBreak: "break-word" }}
                >
                  {item}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
